// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2sBdE","validationTips":"StatementDescriptor_validationTips__2AmFt"};